import React, { useState } from "react";
import Sidebar from "./Comman/Sidebar";
import Header from "./Comman/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function EditProfile() {
  const username = localStorage.getItem("username");
  const navigate = useNavigate();
  const [contactNo, setContactNo] = useState("");

  const updateContact = async (e) => {
    e.preventDefault();

    if (!contactNo) {
      alert("Enter valid contact number");
      return;
    }
    if (!/^[6-9][0-9]{9}$/.test(contactNo)) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "ucontct",
        username: username,
        contactno: contactNo,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data.resCode === 200) {
        alert("Contact updated successfully!");
        navigate("/dashboard");
      } else {
        alert(res.data.message || "Error updating contact");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Server Error");
    }
  };

  const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; }

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 12px; 
      padding: 16px; 
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 1px 15px 15px -10px #bfc9d8;
      display: flex; align-items: center; gap: 12px;
      margin-bottom: 24px;
    }
    .db-input-wrapper.disabled { background: #f8fafc; opacity: 0.7; }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 12px;
      font-weight: 700; width: 100%; font-size: 16px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.3); transition: 0.3s;
      margin-top: 10px;
    }
    .db-modern-btn:hover { transform: translateY(-2px); }
    .db-modern-btn.secondary { background: #f1f5f9; color: #64748b; margin-top: 15px; box-shadow: none; border: 1px solid #e2e8f0; }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Sidebar />
        <Header />
        <section className="nftmax-adashboard nftmax-show">
          <div className="ai-auth-container">
            <div className="ai-auth-card">
              <h2 className="ai-title">Edit Profile</h2>
              <p className="ai-subtitle">Update your personal information</p>

              <form onSubmit={updateContact}>
                <div className="db-input-wrapper disabled">
                  <i className="fa fa-user" style={{ color: '#006fe3' }}></i>
                  <input
                    className="db-input"
                    type="text"
                    value={username}
                    disabled
                  />
                </div>

                <div className="db-input-wrapper">
                  <i className="fa fa-phone" style={{ color: '#006fe3' }}></i>
                  <input
                    className="db-input"
                    type="text"
                    placeholder="New Contact Number"
                    value={contactNo}
                    onChange={(e) => setContactNo(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="db-modern-btn">
                  Save Changes
                </button>

                <button type="button" className="db-modern-btn secondary" onClick={() => navigate("/dashboard")}>
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
